export default function getEnv(env) {
  return process.env.NODE_ENV === env;
}
